/**
 * Loading Spinner Component
 * Loading states
 */
import React from 'react';
import { Loader2 } from 'lucide-react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  text,
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  };

  return (
    <div className={`flex flex-col items-center justify-center animate-in fade-in duration-500 delay-150 ${className}`}>
      <Loader2 className={`animate-spin text-brand-600 ${sizeClasses[size]}`} />
      {text && <p className="mt-2 text-sm text-slate-500 dark:text-slate-400 font-medium">{text}</p>}
    </div>
  );
};

